import { Thunder } from '@nu-art/thunderstorm-frontend/index';
import { __stringify, RuntimeModules, ServerErrorSeverity } from '@nu-art/ts-common';
import { AdvisorRuntimeIDBGroup } from '@app/advisor-shared';
import { AdvisorStaticIDBGroup } from './modules/ModuleFE_AdvisorStatic.js';
import { SlackBuilderFE } from '@nu-art/slack-frontend/SlackBuilderFE';
import { ModuleFE_AdvisorSession } from './_entity/advisor-session/index.js';
export const AdvisorRuntimeModules = {
    getStaticModules: () => {
        return RuntimeModules().filter(module => module.dbDef?.frontend?.group === AdvisorStaticIDBGroup);
    },
    getRuntimeModules: () => {
        return RuntimeModules().filter(module => module.dbDef?.frontend?.group === AdvisorRuntimeIDBGroup);
    }
};
export const AdvisorRunTimeRouteKey = 'advisor-downtime';
export const UserTypesToRouteKeys = {
    'nurse': 'nurse',
    'physician': 'physician',
    'sandbox-orders': 'orders',
    'sandbox-nlp': 'nlp',
    'sandbox-FHIR-query': 'FHIR-query',
    'avatar-mode': 'avatar-mode',
};
export const UrlUserTypeMap = {
    nurse: `${window.location.origin}/advisor/nurse`,
    physician: `${window.location.origin}/advisor/physician`,
    'avatar-mode': `${window.location.origin}/advisor/avatar-mode`,
    'sandbox-orders': `${window.location.origin}/sandbox/order`,
    'sandbox-nlp': `${window.location.origin}/sandbox/nlp`,
    'sandbox-FHIR-query': `${window.location.origin}/sandbox/FHIR-query`,
};
export const filterByEncounterId = (encounterId) => {
    return (item) => {
        return item.encounterId === encounterId;
    };
};
export const sendValidateCacheMessage = (invalidItems, moduleName) => {
    // format issued data as a buffer to send in slack
    return new SlackBuilderFE(`_cache-validation-issues`)
        .addBlocks(SlackBuilderFE.TextSectionWithTitle(`${SlackBuilderFE.SeverityEmoji(ServerErrorSeverity.Critical)} Invalid cache data for module *${moduleName}*`, `*Env:* ${Thunder.getInstance().getEnvironment()}\n*EncounterId:* ${ModuleFE_AdvisorSession.getCurrentEncounterId()}`))
        .addBlocks(SlackBuilderFE.TextSection(`\`\`\`${__stringify(invalidItems, true)}\`\`\``))
        .addBlocks(SlackBuilderFE.TextSection(`*Env:* ${Thunder.getInstance().getEnvironment()}`))
        .send();
};
//# sourceMappingURL=consts.js.map